import type { Ref } from 'vue'

import { useHandleFetchError } from '../../../cms/composables/useHandleFetchError'

type ErrorRef = Ref<{ statusCode: number; message: string } | undefined>

export function useHandleArticleFetchErrors({
  contentErrorRef,
  votesErrorRef,
  relatedArticlesErrorRef,
}: {
  contentErrorRef: ErrorRef
  votesErrorRef: ErrorRef
  relatedArticlesErrorRef: ErrorRef
}) {
  useHandleFetchError(contentErrorRef)

  if (votesErrorRef.value?.statusCode !== 404) {
    useHandleFetchError(votesErrorRef)
  }

  if (relatedArticlesErrorRef.value?.statusCode !== 404) {
    useHandleFetchError(relatedArticlesErrorRef)
  }
}
